import React, { useState, useEffect, useCallback } from "react";
import UserAdministrationDetailsView from "./user-administration-datails.view";
import UserAdministrationRoleAssignView from "./user-administration-role-assign.view";
import UserAdministrationEnterpriseView from "./user-administration-enterprise-assign.view";
import UserAdministrationDisableUserView from "./user-administration-disable-user.view";
import UserAdministrationAddNewUserView from "./user-administration-add-new-user.view";
import "./user-administration-configurations.view.css";
import {
  UserService,
  UserDocService,
  LocalStorageService,
  DomainService,
} from "../../../../services";
import { SimpleLoading } from "../../../pures";
import { profileIconDefault } from "../../../../assets/logos/icons";

const UserAdministrationConfigurationsView = ({
  selectedUser,
  hideShowDetails,
  nameComponentUser,
  setNameComponentUser,
  token,
  rolesBySignatureProfile,
  setHeaderTitleinDetail,
  validators,
  user,
  userAdmin,
  forceRefresh,
  setShowDetails,
  showLoadingRequesting,
  showCompletedRequesting,
  showErrorRequesting,
  showWarningRequesting,
  toggleCompletedRequesting,
  toggleLoadingRequesting,
  toggleErrorRequesting,
  toggleWarningRequesting,
  message,
  allPermissions,
  t
}) => {
  const [rolesByEmailUser, setRolesByEmailUser] = useState({});
  const [companiesRolesByUser, setCompaniesRolesByUser] = useState({});
  const [showGettingData, setShowGettingData] = useState(false);
  const [showDetailComponent, setShowComponentDetail] = useState(false);

  const [imgProfileSubtitle, setImgProfileSubtitle] = useState(
    selectedUser.profilePicture || profileIconDefault
  );

  //Change profile image in SubtitleHLPure
  useEffect(() => {
    setImgProfileSubtitle(selectedUser.profilePicture || profileIconDefault);
  }, [imgProfileSubtitle]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const saveRolesAndProfilesForUser = async (token, userProfileData) => {
    toggleLoadingRequesting(true);
    try {
      let userService = new UserService(process.env.REACT_APP_MIFIRMA_API);
      let res = await userService.createRolesAndSignatureProfilesForUser(
        token,
        userProfileData
      );
      if (res && res.statusCode === 200) {
        let usersCollaboratorAdmin =
          await userService.getUsersCollaboratorAdmin(token);
        let rolesBySignatureProfile =
          await userService.getRolesSignatureProfile(token);
        let filteredRoles = rolesBySignatureProfile;

        usersCollaboratorAdmin.map((user) => {
          user.status = user.active;
          let nameComplete =
            user.firstName +
            " " +
            user.firstLastName +
            " " +
            user.secondLastName +
            " ";
          user.name = nameComplete;
          user.iconTrashActive = (!user.firstName && !user.firstLastName && user.active) ? true : false
          return usersCollaboratorAdmin;
        });

        // let companiesRolesByUser = await userService.getUserRolesCompany(
        //   token,
        //   selectedUser.email
        // );
        toggleLoadingRequesting(false);
        toggleCompletedRequesting(
          true,
          "",
          usersCollaboratorAdmin,
          filteredRoles.data
          // companiesRolesByUser.data
        );
        // hideShowDetails();
        setTimeout(() => {
          hideShowDetails();
        }, 4000);
      } else {
        toggleLoadingRequesting(false);
        toggleErrorRequesting(true, "");
        setTimeout(() => {
          hideShowDetails();
        }, 4000);
      }
    } catch (error) {
      toggleLoadingRequesting(false);
      toggleErrorRequesting(true, "");
      setTimeout(() => {
        hideShowDetails();
      }, 4000);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const saveStatusForUser = async (token, userStatus) => {
    toggleLoadingRequesting(true);
    try {
      let userService = new UserService(process.env.REACT_APP_MIFIRMA_API);
      let res = await userService.updateUserStatus(token, userStatus);
      if (res && res.statusCode === 200) {
        let usersCollaboratorAdmin =
          await userService.getUsersCollaboratorAdmin(token);
        let rolesBySignatureProfile =
          await userService.getRolesSignatureProfile(token);
        let filteredRoles = rolesBySignatureProfile;
        usersCollaboratorAdmin.map((user) => {
          user.status = user.active;
          let nameComplete =
            user.firstName +
            " " +
            user.firstLastName +
            " " +
            user.secondLastName +
            " ";
          user.name = nameComplete;
          user.iconTrashActive = (!user.firstName && !user.firstLastName && user.active) ? true : false
          return usersCollaboratorAdmin;
        });
        toggleLoadingRequesting(false);
        toggleCompletedRequesting(
          true,
          "",
          usersCollaboratorAdmin,
          filteredRoles.data
        );
        //hideShowDetails();
        setTimeout(() => {
          hideShowDetails();
        }, 4000);
      } else {
        toggleLoadingRequesting(false);
        toggleErrorRequesting(true, "");
        setTimeout(() => {
          hideShowDetails();
        }, 4000);
      }
    } catch (error) {
      toggleLoadingRequesting(false);
      toggleErrorRequesting(true, " ");
      setTimeout(() => {
        hideShowDetails();
      }, 4000);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const saveNewUser = async (token, newEmail) => {
    toggleLoadingRequesting(true);
    try {
      let userService = new UserService(process.env.REACT_APP_MIFIRMA_API);
      let domainService = new DomainService(process.env.REACT_APP_MIFIRMA_API);

      let domains = await domainService.getDomains(token);

      let emailDomainSplit = newEmail.email.split("@")[1];
      let emailForbidden = true;

      for (var i = 0; i < domains.length; i++) {
        if (emailDomainSplit === domains[i].name) {
          emailForbidden = false;
          break;
        }
      }
      if (emailForbidden) {
        toggleLoadingRequesting(false);
        toggleWarningRequesting(true, "El dominio del correo ingresado no está autorizado. Favor de verificar.")
        return false;
      }
      let res = await userService.createNewUserCollaborator(token, newEmail);

      if (res && res.statusCode === 200) {
        let usersCollaboratorAdmin =
          await userService.getUsersCollaboratorAdmin(token);
        let rolesBySignatureProfile =
          await userService.getRolesSignatureProfile(token);
        let filteredRoles = rolesBySignatureProfile;
        //hideShowDetails();
        usersCollaboratorAdmin.map((user) => {
          user.status = user.active;
          let nameComplete =
            user.firstName +
            " " +
            user.firstLastName +
            " " +
            user.secondLastName +
            " ";
          user.name = nameComplete;
          user.iconTrashActive = (!user.firstName && !user.firstLastName && user.active) ? true : false
          return usersCollaboratorAdmin;
        });
        toggleLoadingRequesting(false);
        toggleCompletedRequesting(
          true,
          "",
          usersCollaboratorAdmin,
          filteredRoles.data
        );
        setTimeout(() => {
          hideShowDetails();
        }, 4000);
      } else if (res.statusCode === -1) {
        toggleLoadingRequesting(false);
        toggleWarningRequesting(true, "Este usuario ya existe.");
      }
    } catch (error) {
      toggleLoadingRequesting(false);
      toggleErrorRequesting(true, "");
      setTimeout(() => {
        hideShowDetails();
      }, 4000);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const saveNewCompaniesRolesForUser = async (token, newRoles) => {
    toggleLoadingRequesting(true);
    let userService = new UserService(process.env.REACT_APP_MIFIRMA_API);
    let res = await userService.saveRolesForUserByCompany(token, newRoles);
    try {
      if (res && res.statusCode === 200) {
        let usersCollaboratorAdmin =
          await userService.getUsersCollaboratorAdmin(token);
        let rolesBySignatureProfile =
          await userService.getRolesSignatureProfile(token);
        let filteredRoles = rolesBySignatureProfile;

        usersCollaboratorAdmin.map((user) => {
          user.status = user.active;
          let nameComplete =
            user.firstName +
            " " +
            user.firstLastName +
            " " +
            user.secondLastName +
            " ";
          user.name = nameComplete;
          user.iconTrashActive = (!user.firstName && !user.firstLastName && user.active) ? true : false
          return usersCollaboratorAdmin;
        });
        toggleLoadingRequesting(false);
        toggleCompletedRequesting(
          true,
          "",
          usersCollaboratorAdmin,
          filteredRoles.data
        );
        setTimeout(() => {
          hideShowDetails();
        }, 4000);
        //hideShowDetails();
      } else {
        toggleLoadingRequesting(false);
        toggleErrorRequesting(true, "");
        setTimeout(() => {
          hideShowDetails();
        }, 4000);
      }
    } catch (error) {
      toggleLoadingRequesting(false);
      toggleErrorRequesting(true, "");
      setTimeout(() => {
        hideShowDetails();
      }, 4000);
    }
  };

  const toggleShowDetailComponent = () => {
    setShowComponentDetail(false);
    setNameComponentUser(t("userAdministrationView.grid.actions.view.detail"));
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const getRolesCompaniesAndEmail = async () => {
    try {
      setShowGettingData(true);
      if (selectedUser.email !== "" || selectedUser.email !== undefined) {
        let userService = new UserService(process.env.REACT_APP_MIFIRMA_API);
        let rolesByEmail = await userService.getRolesForUserByEmail(
          token,
          selectedUser.email
        );
        if (rolesByEmail.statusCode === 200) {
          setRolesByEmailUser(rolesByEmail.data);
          setShowGettingData(false);
        }
      }
    } catch {
      return false;
    }
  };

  const getCompaniesRolesByUser = async () => {
    try {
      setShowGettingData(true);
      if (selectedUser.email !== "" || selectedUser.email !== undefined) {
        let userService = new UserService(process.env.REACT_APP_MIFIRMA_API);
        let companiesRolesByUser = await userService.getUserRolesCompany(
          token,
          selectedUser.email
        );
        if (companiesRolesByUser.statusCode === 200) {
          let companiesRoles = []
          if (companiesRolesByUser.data) {
            companiesRoles = companiesRolesByUser.data.map((compnayRole) => {
              compnayRole.permissions = []
              return compnayRole
            })

          }
          setCompaniesRolesByUser(companiesRoles);
          setShowGettingData(false);
        }
      }
    } catch {
      return false;
    }
  };

  useEffect(() => {
    if (nameComponentUser == t("userAdministrationView.grid.actions.assign.companies")) {
      getCompaniesRolesByUser();
    } else if (nameComponentUser == t("userAdministrationView.grid.actions.assign.roles")) {
      getRolesCompaniesAndEmail();
    }
  }, [nameComponentUser]);

  switch (nameComponentUser) {
    case t("userAdministrationView.grid.actions.view.detail"):
      return (
        <UserAdministrationDetailsView
          selectedUser={selectedUser}
          hideShowDetails={hideShowDetails}
          setNameComponentUser={setNameComponentUser}
          setHeaderTitleinDetail={setHeaderTitleinDetail}
          setShowComponentDetail={setShowComponentDetail}
          setShowDetails={setShowDetails}
          showDetailComponent={showDetailComponent}
          showLoadingRequesting={showLoadingRequesting}
          showCompletedRequesting={showCompletedRequesting}
          showErrorRequesting={showErrorRequesting}
          toggleCompletedRequesting={toggleCompletedRequesting}
          toggleLoadingRequesting={toggleLoadingRequesting}
          toggleErrorRequesting={toggleErrorRequesting}
          message={message}
          toggleWarningRequesting={toggleWarningRequesting}
          showWarningRequesting={showWarningRequesting}
          imgProfileSubtitle={imgProfileSubtitle}
          t={t}
        />
      );
    case t("userAdministrationView.grid.actions.assign.roles"):
      return showGettingData ? (
        <div className="UserAdministrationConfigurationsView-loader">
          <SimpleLoading />
        </div>
      ) : (
        <UserAdministrationRoleAssignView
          selectedUser={selectedUser}
          hideShowDetails={hideShowDetails}
          token={token}
          rolesBySignatureProfile={rolesBySignatureProfile}
          rolesByEmailUser={rolesByEmailUser}
          emailAdmin={userAdmin}
          getRolesCompaniesAndEmail={getRolesCompaniesAndEmail}
          saveRolesAndProfilesForUser={saveRolesAndProfilesForUser}
          showDetailComponent={showDetailComponent}
          toggleShowDetailComponent={toggleShowDetailComponent}
          showLoadingRequesting={showLoadingRequesting}
          showCompletedRequesting={showCompletedRequesting}
          showErrorRequesting={showErrorRequesting}
          toggleCompletedRequesting={toggleCompletedRequesting}
          toggleLoadingRequesting={toggleLoadingRequesting}
          toggleErrorRequesting={toggleErrorRequesting}
          setShowDetails={setShowDetails}
          message={message}
          toggleWarningRequesting={toggleWarningRequesting}
          showWarningRequesting={showWarningRequesting}
          imgProfileSubtitle={imgProfileSubtitle}
        />
      );
    case t("userAdministrationView.grid.actions.assign.companies"):
      return showGettingData ? (
        <div className="UserAdministrationConfigurationsView-loader">
          <SimpleLoading />
        </div>
      ) : (
        <UserAdministrationEnterpriseView
          selectedUser={selectedUser}
          hideShowDetails={hideShowDetails}
          companiesRolesByUser={companiesRolesByUser}
          rolesByEmailUser={rolesByEmailUser}
          getRolesCompaniesAndEmail={getRolesCompaniesAndEmail}
          rolesBySignatureProfile={rolesBySignatureProfile}
          saveNewCompaniesRolesForUser={saveNewCompaniesRolesForUser}
          token={token}
          toggleShowDetailComponent={toggleShowDetailComponent}
          showLoadingRequesting={showLoadingRequesting}
          showDetailComponent={showDetailComponent}
          showCompletedRequesting={showCompletedRequesting}
          showErrorRequesting={showErrorRequesting}
          toggleCompletedRequesting={toggleCompletedRequesting}
          toggleLoadingRequesting={toggleLoadingRequesting}
          toggleErrorRequesting={toggleErrorRequesting}
          message={message}
          setShowDetails={setShowDetails}
          imgProfileSubtitle={imgProfileSubtitle}
          toggleWarningRequesting={toggleWarningRequesting}
          showWarningRequesting={showWarningRequesting}
          allPermissions={allPermissions}
        />
      );
    case t("userAdministrationView.grid.actions.disable"):
      return (
        <UserAdministrationDisableUserView
          selectedUser={selectedUser}
          hideShowDetails={hideShowDetails}
          saveStatusForUser={saveStatusForUser}
          token={token}
          toggleShowDetailComponent={toggleShowDetailComponent}
          showLoadingRequesting={showLoadingRequesting}
          showDetailComponent={showDetailComponent}
          showCompletedRequesting={showCompletedRequesting}
          showErrorRequesting={showErrorRequesting}
          toggleCompletedRequesting={toggleCompletedRequesting}
          toggleLoadingRequesting={toggleLoadingRequesting}
          toggleErrorRequesting={toggleErrorRequesting}
          message={message}
          setShowDetails={setShowDetails}
          imgProfileSubtitle={imgProfileSubtitle}
          toggleWarningRequesting={toggleWarningRequesting}
          showWarningRequesting={showWarningRequesting}
        />
      );
    case "Agregar usuario":
      return (
        <UserAdministrationAddNewUserView
          selectedUser={selectedUser}
          hideShowDetails={hideShowDetails}
          validators={validators}
          saveNewUser={saveNewUser}
          showLoadingRequesting={showLoadingRequesting}
          token={token}
          showCompletedRequesting={showCompletedRequesting}
          showDetailComponent={showDetailComponent}
          showErrorRequesting={showErrorRequesting}
          toggleCompletedRequesting={toggleCompletedRequesting}
          toggleLoadingRequesting={toggleLoadingRequesting}
          toggleErrorRequesting={toggleErrorRequesting}
          message={message}
          setShowDetails={setShowDetails}
          imgProfileSubtitle={imgProfileSubtitle}
          toggleWarningRequesting={toggleWarningRequesting}
          showWarningRequesting={showWarningRequesting}
        />
      );
    default:
      return <></>;
  }
};

export default UserAdministrationConfigurationsView;
